import type { ReactNode } from 'react'
import { ArrowUpRight, ArrowLeft, RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '../i18n/Link'

export function PageHeading({
  label,
  title,
  accent,
  description,
  children,
}: {
  label: string
  title: string
  accent: string
  description: string
  children?: ReactNode
}) {
  return (
    <header className="interior-heading">
      <div>
        <span className="eyebrow">{label}</span>
        <h1>
          {title}
          <br />
          <span>{accent}</span>
        </h1>
        <p>{description}</p>
      </div>
      {children}
    </header>
  )
}
export function InnerTrail({ name }: { name: string }) {
  const { t } = useTranslation('common')
  return (
    <div className="inner-trail">
      <Link to="/">
        <ArrowLeft size={14} /> {t('interior.home')}
      </Link>
      <span>/</span>
      <span>{name}</span>
      <span className="trail-edition">{t('siteName')}</span>
    </div>
  )
}
export function ServiceState({
  loading,
  error,
  empty,
  retry,
}: {
  loading: boolean
  error: string | null
  empty: boolean
  retry: () => void
}) {
  const { t } = useTranslation('common')
  if (!loading && !error && !empty) return null
  return (
    <div className="service-state" role="status">
      <RefreshCw size={22} className={loading ? 'animate-spin' : ''} />
      <h3>
        {loading ? t('interior.loadingTitle') : error ? t('interior.errorTitle') : t('interior.emptyTitle')}
      </h3>
      <p>{loading ? t('interior.loadingText') : t('interior.retryText')}</p>
      {!loading && (
        <div>
          <button className="outline-button" onClick={retry}>
            {t('interior.retry')}
          </button>
          <Link className="text-link" to="/contact">
            {t('interior.contactUs')} <ArrowUpRight size={16} />
          </Link>
        </div>
      )}
    </div>
  )
}
export function InnerClosing({ title, text }: { title?: string; text?: string }) {
  const { t } = useTranslation('common')
  return (
    <aside className="inner-closing">
      <img src="/brand/mark.svg" width="85" height="64" alt="" />
      <div>
        <h2>{title ?? t('interior.closingTitle')}</h2>
        <p>{text ?? t('interior.closingText')}</p>
      </div>
      <Link to="/contact" className="jade-button">
        {t('interior.talk')} <ArrowUpRight size={17} />
      </Link>
    </aside>
  )
}
